import { render, staticRenderFns } from "./CarDetails2.vue?vue&type=template&id=2e5bec01&scoped=true"
import script from "./CarDetails2.vue?vue&type=script&lang=js"
export * from "./CarDetails2.vue?vue&type=script&lang=js"
import style0 from "./CarDetails2.vue?vue&type=style&index=0&id=2e5bec01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bec01",
  null
  
)

export default component.exports